import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('issuer_source', '/issuer_sources')
const actions = generator.generate()

export default actions
